import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import Fragment from 'vue-fragment'
import '@/assets/scss/style.scss'
import formCreate from '@form-create/element-ui'
import FcDesigner from '@form-create/designer'
import ELEMENT from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ELEMENT)
Vue.use(formCreate)
Vue.use(FcDesigner)
Vue.config.productionTip = false

Vue.use(Fragment.Plugin)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
